import 'es6-shim';
import 'location-origin';
import includes from 'array-includes';
import { patchNoticeConsoleError } from './utils/report';
import redirectOnHash from './utils/location';
import store from './store';

// ES6 polyfill
require('es6-promise').polyfill();

includes.shim();

// Redirect all errors to NewRelic
patchNoticeConsoleError();

// We have to check is current url contains hashbang version of route
// and redirect in this case to correct html5 version
// this required by S3 and CloudFront.
// Could be removed when static servers will able handle html5 redirects.
// [OPS-2028]
redirectOnHash(store);



// WEBPACK FOOTER //
// ./src/patch.js